
import { BIG_CARD_DATA } from "const/case-study/road-assistance-mobile-app-case-study";
import { useEffect, useState } from "react";
import BigCard from "./BigCard";
import MarqueeHeading from "./common/MarqueeHeading";
import SpaceWrapper from "./common/SpaceWrapper";

const DefineSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    }  
    else {
      setIsMobile(false);
    }
  }, []);
  return (
    <SpaceWrapper className="!py-16 !px-6">
      <div className="hidden md:block">
        <MarqueeHeading
          marqueeTitle="DEFINE"
          paragraph="With the information we gained from interviewing the target users, we created a representative so that we could better understand the concerns and needs of the users. Now we can come up with better ideas."
          smallTitle="Define"
        />
      </div>
      {/* for mobile */}
      {isMobile && (
        <div className="block md:hidden">
          <h2 className="font-bold text-5xl text-white">
            <span className="font-gilroy">Define</span>
          </h2>
          <p className="text-white font-normal text-lg text-justify mt-10 mb-16">
            <span className="font-gilroy">
              With the information we gained from interviewing the target users,
              we created a representative so that we could better understand the
              concerns and needs of the users. Now we can come up with better
              ideas.
            </span>
          </p>
        </div>
      )}
      {BIG_CARD_DATA.map((values, index) => (
        <BigCard
          key={values.img}
          alts={
            index === 0
              ? "A woman's headshot as one of user of roadside service app"
              : "A Man's headshot as one of user of roadside service app"
          }
          data={values}
        />
      ))}
    </SpaceWrapper>
  );
};
export default DefineSection;
